(function () {
  'use strict';

  function formatMoney(cents) {
    // Currency-aware formatter (fixed Sep 1 2026: hardcoded '$' showed on
    // non-USD stores whenever JS swapped the price after a variant change).
    if (window.fzMoney) return fzMoney(cents);
    var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var symbols = { USD: '$', GBP: '\u00a3', EUR: '\u20ac', CAD: 'CA$', AUD: 'A$' };
    var amount = (cents / 100).toFixed(2);
    if (code === 'EUR') amount = amount.replace('.', ',');
    return (symbols[code] || '') + amount;
  }

  // Extracts just the base filename from a Shopify CDN image URL, ignoring
  // query params (?v=..., ?width=...) and any protocol/host differences.
  // More reliable than a raw indexOf() substring check.
  function getCdnFilename(src) {
    if (!src) return '';
    try {
      var pathname = src.indexOf('http') === 0 || src.indexOf('//') === 0
        ? new URL(src, window.location.origin).pathname
        : src.split('?')[0];
      var parts = pathname.split('/');
      return parts[parts.length - 1];
    } catch (err) {
      return src.split('?')[0].split('/').pop();
    }
  }

  function initCard(card) {
    if (!card || card.dataset.pgcInitialized) return;
    card.dataset.pgcInitialized = 'true';

    var variants = [];
    try {
      variants = JSON.parse(card.dataset.variants || '[]');
    } catch (err) {
      console.warn('Product Grid Carousel: invalid variants JSON', err);
    }

    var colorIndex = parseInt(card.dataset.colorIndex, 10);
    var sizeIndex = parseInt(card.dataset.sizeIndex, 10);

    var imageWrap = card.querySelector('[data-pgc-image-wrap]');
    var images = card.querySelectorAll('[data-pgc-image]');
    var prevBtn = card.querySelector('[data-pgc-prev]');
    var nextBtn = card.querySelector('[data-pgc-next]');
    var swatchWrap = card.querySelector('[data-pgc-swatches]');
    var sizeSelect = card.querySelector('[data-pgc-size-select]');
    var colorLabel = card.querySelector('[data-pgc-color-label]');
    var priceEl = card.querySelector('[data-pgc-price]');
    var comparePriceEl = card.querySelector('[data-pgc-compare-price]');
    var variantIdInput = card.querySelector('[data-pgc-variant-id]');
    var addToCartBtn = card.querySelector('[data-pgc-add-to-cart]');

    var currentImageIndex = 0;
    var selectedColor = swatchWrap ? swatchWrap.querySelector('.is-active')?.dataset.value : null;
    var selectedSize = sizeSelect ? sizeSelect.value : null;

    // ---------- Image carousel ----------
    function showImage(index) {
      if (!images.length) return;
      index = Math.max(0, Math.min(index, images.length - 1));
      images.forEach(function (img, i) {
        img.style.display = i === index ? '' : 'none';
        img.classList.toggle('is-active', i === index);
      });
      currentImageIndex = index;
      if (prevBtn) prevBtn.style.display = index === 0 ? 'none' : 'flex';
      if (nextBtn) nextBtn.style.display = index === images.length - 1 ? 'none' : 'flex';
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        showImage(currentImageIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        showImage(currentImageIndex + 1);
      });
    }

    // ---------- Variant matching ----------
    function findMatchingVariant() {
      if (!variants.length) return null;
      return variants.find(function (v) {
        var optMatch = true;
        if (colorIndex > -1 && selectedColor) {
          optMatch = optMatch && v['option' + (colorIndex + 1)] === selectedColor;
        }
        if (sizeIndex > -1 && selectedSize) {
          optMatch = optMatch && v['option' + (sizeIndex + 1)] === selectedSize;
        }
        return optMatch;
      }) || null;
    }

    function updateForVariant(variant) {
      if (!variant) {
        // FIX: if no variant could be matched (e.g. variants JSON failed to
        // parse, or the selected combination doesn't exist), fall back to
        // disabling add-to-cart instead of silently keeping the previous
        // (possibly wrong) variant id in the hidden input.
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = (window.fzT && fzT.grid_unavailable) || 'Unavailable';
        }
        console.warn('Product Grid Carousel: could not resolve a variant for the current selection.');
        return;
      }

      if (variantIdInput) variantIdInput.value = variant.id;

      if (priceEl) priceEl.textContent = formatMoney(variant.price);

      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.style.display = '';
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
        } else {
          comparePriceEl.style.display = 'none';
        }
      }

      if (addToCartBtn) {
        if (variant.available) {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = (window.fzT && fzT.grid_add) || 'Add to cart';
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = (window.fzT && fzT.grid_sold_out) || 'Sold out';
        }
      }

      // Try to switch to a product image matching this variant's featured image, if any.
      if (images.length) {
        if (!variant.featured_image) {
          // This is the most common reason swatch clicks don't change the
          // image: the variant has no "Variant image" assigned in Shopify
          // Admin, so there is nothing for the JS to switch to.
          console.warn(
            'Product Grid Carousel: variant', variant.id,
            'has no featured_image assigned in Shopify Admin, image will not change.'
          );
        } else {
          var targetFile = getCdnFilename(variant.featured_image.src);
          var foundIndex = -1;
          images.forEach(function (img, i) {
            if (foundIndex === -1 && getCdnFilename(img.src) === targetFile) {
              foundIndex = i;
            }
          });
          if (foundIndex > -1) {
            showImage(foundIndex);
          } else {
            console.warn(
              'Product Grid Carousel: could not find a rendered image matching variant',
              variant.id, 'featured_image', variant.featured_image.src
            );
          }
        }
      }
    }

    // ---------- Swatch clicks ----------
    if (swatchWrap) {
      swatchWrap.querySelectorAll('[data-pgc-swatch]').forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          swatchWrap.querySelectorAll('[data-pgc-swatch]').forEach(function (s) {
            s.classList.remove('is-active');
          });
          swatch.classList.add('is-active');
          selectedColor = swatch.dataset.value;
          if (colorLabel) colorLabel.textContent = selectedColor;
          updateForVariant(findMatchingVariant());
        });
      });
    }

    // ---------- Size select ----------
    if (sizeSelect) {
      sizeSelect.addEventListener('change', function () {
        selectedSize = sizeSelect.value;
        updateForVariant(findMatchingVariant());
      });
    }

    // ---------- Add to cart ----------
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function () {
        if (addToCartBtn.disabled) return;
        var variantId = variantIdInput ? variantIdInput.value : null;
        if (!variantId) {
          console.warn('Product Grid Carousel: no variant id found for add to cart.');
          return;
        }

        // FIX: actually disable the button while the request is in flight,
        // not just add a CSS class. Prevents double/parallel add-to-cart
        // clicks (visible in the screenshots as two cards stuck on
        // "ADDING..." at once) which can trigger rate limiting or race
        // conditions on the cart.
        addToCartBtn.disabled = true;
        addToCartBtn.classList.add('is-loading');
        var originalText = addToCartBtn.textContent;
        addToCartBtn.textContent = (window.fzT && fzT.grid_adding) || 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (r) {
            // FIX: read and surface the real Shopify error body instead of
            // discarding it. Shopify returns a JSON body with a
            // `description` (e.g. "Sold Out", "You can add 0 more of this
            // item to your cart.") even on non-2xx responses.
            if (!r.ok) {
              return r.json()
                .catch(function () {
                  // Body wasn't JSON / couldn't be parsed
                  throw new Error(((window.fzT && fzT.grid_add_failed) || 'Add to cart failed with status') + ' ' + r.status);
                })
                .then(function (body) {
                  console.error('Add to cart failed:', r.status, body);
                  throw new Error(body && body.description ? body.description : ('status ' + r.status));
                });
            }
            return r.json();
          })
          .then(function () {
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.open === 'function') {
              drawer.open();
              fetch('/?section_id=cart-drawer')
                .then(function (r) { return r.text(); })
                .then(function (html) {
                  var doc = new DOMParser().parseFromString(html, 'text/html');
                  var newDrawer = doc.querySelector('cart-drawer');
                  if (newDrawer) drawer.innerHTML = newDrawer.innerHTML;
                })
                .catch(function (err) { console.warn('Cart drawer refresh failed:', err); });
            } else {
              // No drawer found on this theme; fall back to cart page.
              window.location.href = (window.fzLocalUrl ? fzLocalUrl('/cart') : '/cart');
            }
          })
          .catch(function (err) {
            console.warn('Add to cart error:', err);
            // FIX: show the real reason to the user when we have one,
            // instead of always showing the generic message.
            var message = (err && err.message && err.message !== 'Failed to fetch')
              ? err.message
              : ((window.fzT && fzT.grid_add_error) || 'Sorry, something went wrong adding this to your cart.');
            alert(message);
          })
          .finally(function () {
            addToCartBtn.disabled = false;
            addToCartBtn.classList.remove('is-loading');
            addToCartBtn.textContent = originalText;
          });
      });
    }
  }

  function initAllCards(root) {
    (root || document).querySelectorAll('[data-pgc-card]').forEach(initCard);
  }

  // ---------- Load more (AJAX pagination) ----------
  function initLoadMore(section) {
    var btn = section.querySelector('[data-pgc-load-more]');
    if (!btn || btn.dataset.pgcInitialized) return;
    btn.dataset.pgcInitialized = 'true';

    var grid = section.querySelector('[data-pgc-grid]');
    var sectionId = section.dataset.sectionId;

    btn.addEventListener('click', function () {
      var nextUrl = btn.dataset.nextUrl;
      if (!nextUrl) return;

      btn.classList.add('is-loading');
      var originalText = btn.textContent;
      btn.textContent = (window.fzT && fzT.grid_loading) || 'Loading...';

      var sectionUrl = nextUrl + (nextUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId;

      fetch(sectionUrl)
        .then(function (r) {
          if (!r.ok) throw new Error('Load more failed with status ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-pgc-grid]');
          var newBtn = doc.querySelector('[data-pgc-load-more]');

          if (newGrid && grid) {
            Array.prototype.forEach.call(newGrid.children, function (card) {
              grid.appendChild(card);
            });
            initAllCards(grid);
          }

          if (newBtn && newBtn.dataset.nextUrl) {
            btn.dataset.nextUrl = newBtn.dataset.nextUrl;
          } else {
            btn.remove();
          }
        })
        .catch(function (err) {
          console.warn('Load more error:', err);
        })
        .finally(function () {
          btn.classList.remove('is-loading');
          btn.textContent = originalText;
        });
    });
  }

  function initSection(section) {
    initAllCards(section);
    initLoadMore(section);
  }

  document.querySelectorAll('.pgc-section').forEach(initSection);

  // Support Shopify theme editor live updates
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.pgc-section');
    if (section) initSection(section);
  });
})();
